module.exports = __webpack_public_path__ + "static/media/3.6b3b39d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/3.png
// module id = 727
// module chunks = 0